export enum ImageConverterErrorType {
    CannotReadFile = "CannotReadFile",
}
